export default "__VITE_ASSET__DWUKAWl9__"